export default {
    setCategoriasArray(state,cat){
        state.categoriasArray = cat
    },
    resetCategorias(state){
        state.categoriasArray = []
    }
}